import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../../shared/shared.module";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/questionnaires.reducer";
import {EffectsModule} from "@ngrx/effects";
import {QuestionnairesEffects} from "./core/questionnaires.effects";
import {MaterialModule} from "../../shared/material-module";
import {
  ManageQuestionnairesScreenComponent
} from './screens/manage-questionnaires-screen/manage-questionnaires-screen.component';
import {
  CreateSurveyScheduleScreenComponent
} from './screens/create-survey-schedule-screen/create-survey-schedule-screen.component';
import {
  CreateSurveySendToScreenComponent
} from './screens/create-survey-send-to-screen/create-survey-send-to-screen.component';
import {
  CreateSurveyFormScreenComponent
} from './screens/create-survey-form-screen/create-survey-form-screen.component';
import {SurveyCreatorModule} from 'survey-creator-angular';
import {
  SendSurveyFiltersComponent
} from './components/send-survey-filters/send-survey-filters.component';
import {
  MyQuestionnairesListScreenComponent
} from './screens/my-questionnaires-list-screen/my-questionnaires-list-screen.component';
import {
  TakeSurveyScreenComponent
} from './screens/take-survey-screen/take-survey-screen.component';
import {SurveyModule} from "survey-angular-ui";
import {
  SurveyReviewScreenComponent
} from './screens/survey-review-screen/survey-review-screen.component';
import {
  ReviewSurveyQuestionsComponent
} from './components/review-survey-questions/review-survey-questions.component';
import {
  EditSurveyScreenComponent
} from './screens/edit-survey-screen/edit-survey-screen.component';
import {
  EditQuestionnaireComponent
} from './components/edit-questionnaire/edit-questionnaire.component';
import {
  EditSettingsComponent
} from './components/edit-settings/edit-settings.component';
import {
  EditSummaryComponent
} from './components/edit-summary/edit-summary.component';
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import { ReviewSurveyResponseScreenComponent } from './screens/review-survey-response-screen/review-survey-response-screen.component';

@NgModule({
  declarations: [
    ManageQuestionnairesScreenComponent,
    CreateSurveyScheduleScreenComponent,
    CreateSurveySendToScreenComponent,
    CreateSurveyFormScreenComponent,
    SendSurveyFiltersComponent,
    MyQuestionnairesListScreenComponent,
    TakeSurveyScreenComponent,
    SurveyReviewScreenComponent,
    ReviewSurveyQuestionsComponent,
    EditSurveyScreenComponent,
    EditQuestionnaireComponent,
    EditSettingsComponent,
    EditSummaryComponent,
    ReviewSurveyResponseScreenComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StoreModule.forFeature('ss-cord.questionnaires', reducer),
    EffectsModule.forFeature(
      [QuestionnairesEffects],
    ),
    SurveyCreatorModule,
    SurveyModule,
    InfiniteScrollModule
  ],

})
export class QuestionnaireModule {
}
